const handlers = {
  onHeaderClick: props => key => {
    const column = props.columns.find(column => {
      if (column.key === key) {
        return true
      }
      return false
    })
    if (!column.sort) {
      return
    }

    let sortDirection = 'ASC'
    if (props.sortDirection === 'ASC') {
      sortDirection = 'DESC'
    }

    props.onSort({
      setSortDirection: props.setSortDirection,
      setSortIndex: props.setSortIndex,
      setSortText: props.setSortText,
      sortBy: key,
      sortDirection: sortDirection,
      sortIndex: props.sortIndex
    })
  }
}

export default handlers
